import { Ref } from "vue";
import mapboxgl from "mapbox-gl";
import { captureException } from "@sentry/vue";

export default function useMapboxControls(map: Ref<mapboxgl.Map | null>) {
	function initControls() {
		if (!map.value) {
			console.error("Map not initialized");
			captureException(new Error("Map not initialized"));
			return;
		}

		map.value.addControl(new mapboxgl.NavigationControl(), "bottom-right");

		map.value.addControl(
			new mapboxgl.GeolocateControl({
				positionOptions: {
					enableHighAccuracy: true,
				},
				trackUserLocation: true,
				showUserLocation: true,
				showAccuracyCircle: true,
			}),
			"bottom-right",
		);

		map.value.addControl(
			new mapboxgl.ScaleControl({
				maxWidth: 80,
				unit: "imperial", // TODO: Customer scale unit
			}),
			"bottom-left",
		);
	}

	map.value?.on("load", initControls);
}
